<template>
    <div class="relative mb-6 last:mb-0">
        <div
            class="card border rounded-lg overflow-hidden cursor-pointer shadow-lg"
            @click="clickCampaign()"
        >
            <div
                class="campaign-image"
                :style="{ 'background-image': `url('${campaign.fullImageUrl}')` }"
            ></div>
            <div class="p-10px pb-8 flex">
                <div class="mb-auto img-size" v-if="agencyLogoUrl()">
                    <img :src="agencyLogoUrl()">
                </div>
                <div class="ml-2 flex-1">
                    <div class="text-primary leading-normal font-main-medium uppercase">{{ campaign.name }}</div>
                    <div class="text-gray-secondary leading-normal">{{ campaign.detail }}</div>
                </div>
            </div>
            <!-- <div class="p-10px pb-8">
                <div class="ml-2">
                    <div class="text-primary leading-normal font-main-medium">{{ campaign.agencyName }}</div>
                    <div class="text-gray-secondary leading-normal">{{ campaign.name }}</div>
                </div>
            </div> -->
        </div>
        <div
            class="label absolute -bottom-3 right-6 h-7 w-40 text-center text-base text-white py-2px uppercase"
        >{{ lbl.detail.view_detail }}</div>
    </div>
</template>
<script>
import LocaleMixin from "@/mixin/LocaleMixin.js";
// import ConfigManager from "@/config/ConfigManager.js";

export default {
    name: "CampaignItem",
    mixins: [LocaleMixin],
    props: {
        campaign: { type: Object, required: true },
    },
    methods: {
        getPointMessage: function () {
            var pointType = this.campaign.pointType == 'get' ? this.lbl.campaign.get_point : this.lbl.campaign.use_point;
            var pointUnit = this.lbl.campaign.point + (this.campaign.pointPerUnit > 1 && this.localeCode == 1033 ? 's' : '');
            return pointType + " " + this.campaign.pointPerUnit + " " + pointUnit;
        },

        clickCampaign: function () {
            let tracking_label = this.campaign.id + '|' + this.campaign.name;
            this.tracking.event('campaign_list', 'click_campaign_list', tracking_label, null);
            if(this.campaign.customFacebookMessage){
                window.location.href = this.campaign.customFacebookMessage;
            }else{
                this.$router.push('/campaign/' + this.campaign.id);
            }
        },
        agencyLogoUrl: function() {
            console.log(this.campaign);
            if (this.campaign.pictures && this.campaign.pictures.length > 1) {
                return this.campaign.pictures[this.campaign.pictures.length - 1].fullImageUrl;
            }
            return "";
            // return ConfigManager.getBlobUrl() + "/config/jcb/agencyLogo/" + this.campaign.id + ".jpg"; // old url
        },
    },
}
</script>
<style lang="scss" scoped>
@import "@/style/base/image.scss";

.card {
    z-index: 1;
}
.campaign-image {
    @include boxRatio($ratio: 66.66%);
}
.label {
    background-image: url("~@/assets/button/bg.svg");
    background-size: 100%;
}

.img-size {
    width: 50px;
}
</style>
